<template>
    <section class="nav" @click="changeType($event)">
        <span v-for="item in type" :class="{'active' : item.value === currentType}" :data-type="item.value">{{
            item.name }}</span>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .nav {
        width: 100%;
        height: 30px;
        > span {
            width: 100px;
            height: 30px;
            border: 1px solid #C6CACF;
            border-radius: 100px;
            display: inline-block;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            &:nth-child(n+2) {
                margin-left: 10px;
            }
            &.active {
                background-color: #2CA4F7;
                color: #FFF;
            }
        }
    }
</style>

<script>
    export default {
        data () {
            return {}
        },
        props: ['type', 'currentType'],
        methods: {
        	// 切换类型
	        changeType (e) {
	        	const ev = e.target;
	        	if (ev.tagName === 'SPAN') {
                    const type = ev.dataset.type;
                    if (type === this.currentType) {
                    	return;
                    }
                    this.$emit('changeNavType', type);
                } else {
	        		return;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Nav.vue?6f013e61